import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';

import { Select } from '@/components/Select';
import { useJobBoardParams } from '@/hooks/JobBoardFilters/useJobBoardParams';
import { useDebounce } from '@/hooks/useDebounce';
import { queries } from '@/queries';

const Location = () => {
  const [locationInput, setLocationInput] = useState('');

  const debouncedLocation = useDebounce(locationInput);

  const { params, setParams } = useJobBoardParams();

  const { location } = params;

  const {
    data: locationSuggestionData,
    isFetching: isLocationSuggestionFetching,
  } = useQuery({
    ...queries.externalOffers.suggestedSearch('LOCATION', debouncedLocation),
    enabled: !!debouncedLocation && debouncedLocation.length > 0,
    keepPreviousData: true,
  });

  const isLocationSuggestionLoading =
    isLocationSuggestionFetching || locationInput !== debouncedLocation;

  const options =
    (debouncedLocation ? locationSuggestionData : [])?.map((val) => ({
      label: val,
      value: val,
    })) ?? [];

  return (
    <div className="w-full">
      <Select
        classNames={{ control: () => 'border-none' }}
        isLoading={isLocationSuggestionLoading}
        sizeVariant="xs"
        variant="candidate-light"
        value={location ? { label: location, value: location } : null}
        isClearable
        noOptionsMessage={(input) =>
          input.inputValue.length > 0 ? undefined : 'Type to search'
        }
        onInputChange={(e) => {
          setLocationInput(e ?? '');
        }}
        prefixIcon="material-symbols-light:location-on-outline"
        prefixIconClassName="!text-neutral-1000"
        onChange={(newValue) => {
          setParams({ location: newValue?.value });
        }}
        options={options}
        isMulti={false}
        placeholder="Enter a location..."
        isSearchable
        className=" flex-1 !border-[#7C6D6D] text-neutral-1000"
      />
    </div>
  );
};

export default Location;
